import { Search } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function SearchBar({ value, onChange, placeholder }: SearchBarProps) {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <Search className="h-5 w-5 text-navy-400 dark:text-navy-500" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full pl-11 pr-4 py-3 border border-navy-200 dark:border-navy-700 rounded-xl leading-5 bg-white dark:bg-navy-800 text-navy-900 dark:text-navy-100 placeholder-navy-400 dark:placeholder-navy-500 focus:outline-none focus:ring-2 focus:ring-accent-400/50 focus:border-accent-400 transition-all duration-200"
        placeholder={placeholder || "Pesquisar..."}
      />
    </div>
  );
}
